module.exports = __webpack_public_path__ + "img/sk.8a5d1557.png";